import React from 'react';
import { Fade } from 'react-reveal';
import styled from 'styled-components';

import { Flex, GradientButton, Text } from '../../../components';

import Trickle from '../../../assets/Trickle.svg';
import UI from '../../../assets/UI.png';

const LogoText = styled.img`
  width: 65%;
  max-width: 300px;
`;

const Preview = styled.img`
  width: 100%;
  max-width: 1132px;
`;

const Header = ({ subText, buttonText, purchase, joinWaitlist }) => {

  const renderPurchaseButton = () => {

    if (purchase) {
      return (
        <GradientButton w="180px" text={buttonText} onClick={() => purchase()} />
      )
    } else {
      return (
        <GradientButton w="180px" text={buttonText} onClick={() => joinWaitlist()} />
      )
    }

  }

  return (
    <Flex id="home" dir="column" w="100%" align="center">
      <LogoText src={Trickle} alt="trickle" />
      <Flex h="64px" />
      <Flex dir="column" w="80%" align="center">
        <Text.Body size="21" center>
          A Steady Drip of Success.
        </Text.Body>
        <Flex h="48px" />
        {renderPurchaseButton()}
        <Flex h="24px" />
        <Text.Body color="#7178B2" size="12" center>
          {subText}
        </Text.Body>
      </Flex>
    </Flex>
  )
};

export default Header;
